// src/components/table/TableCanvas.jsx
import { useSelector, useDispatch } from "react-redux";
import DraggAbleComponentView from "./DraggAbleComponentView";
import useTablePusher from "@/api/lib/pusher/PusherHandler";
import { useEffect } from "react";
import { getBookingById } from "@/api/table-floor/tableFloor";
import { addBookingToTable, removeBookingFromTable, updateTablePendingBookingCount } from "@/redux/slice/table-slice/table-slice";
import { addNewBookingToDetails, setSelectedBookingTable, updateBookingStatusInDetails } from "@/redux/slice/table-slice/booking-table-slice";

export default function BookTableCanvas() {
  const { tables } = useSelector((state) => state.table.table);


  return (
    <>
      <div className="">
        {tables.filter((data) => data.is_visible !== false).map((data, index) => (
          <DraggAbleComponentView key={index} data={data.table_size} id={data.id} fullDetails={data} />
        ))}
      </div>
    </>
  );
}
